import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";

import Link from "../Link";
import ArticleCardBody from "../ArticleCard/ArticleCardBody";

import { filterCategories, filterDifficultyTags } from "../../utils";

const ResultCard = ({ post }) => {
  return (
    <Link to={`/learn/${post.slug}/`}>
      <div id="result-card" className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-xl-3 pt-md-1 pb-3 pb-md-0">
              <GatsbyImage
                image={
                  post.featuredImage.node.localFile.childImageSharp
                    .gatsbyImageData
                }
                className="card-img"
                alt={post.title}
              />
            </div>
            <div className="col-md-6 col-xl-9">
              <ArticleCardBody
                classNames="filtration-page"
                cardInfoClassNames="justify-content-lg-start"
                title={post.title}
                excerpt={post.excerpt}
                date={post.date}
                level={filterDifficultyTags(post.tags.nodes)}
                categories={filterCategories(post.categories.nodes, [
                  "articles",
                  "podcasts",
                ])}
              />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ResultCard;
